// Reviewed
import React, { Component} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { ProductListNewURL} from "../../APIServices/ProductListRequest";
import { Link } from "react-router-dom";

class NewArrival extends Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },

      DataList: [],
    };
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  componentDidMount() {
    this.SelectProductList();
  }
  SelectProductList = () => {
    axios.get(ProductListNewURL()).then((res) => {
      this.setState({ DataList: res.data });
    });
  };

  Ratting(which) {
    let str = ``;
    if (which > 0) {
      for (let i = 0; i < which; i++) {
        str += `<i class="fa-solid text-warning fa-star"></i>`;
      }
    }
    return str;
  }

  render() {
    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      responsive: [
        {
          breakpoint: 1352,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };

    let products = this.state.DataList;

    if (products.length > 0) {
      if (products.length < 6) {
        let i = 0;
        while (products.length < 6) {
          products.push(this.state.DataList[i]);
          i++;
        }
      }
    }

    return (
      <>
        <div id="WeeklyProduct">
          <div className="container">
            <div className="row">
              <div className="CarouselButton pt-3  pb-3 pb-lg-0 pt-lg-0  d-flex d-lg-block justify-content-between align-items-center justify-content-lg-start flex col-12 col-lg-3 ">
                <h3
                  className="text-start  SectionTitle fw-bold text-white"
                  style={{ lineHeight: "1.5" }}
                >
                  এ সপ্তাহের নতুন পন্য{" "}
                </h3>
                <div className="Buttons text-start mt-lg-4">
                  <button
                    onClick={this.previous}
                    className="prev btn rounded-circle btn-outline-white"
                  >
                    <i className="fa-solid fa-angle-left"></i>
                  </button>
                  <button
                    onClick={this.next}
                    className="next btn rounded-circle btn-outline-white"
                  >
                    <i className="fa-solid fa-angle-right"></i>
                  </button>
                </div>
              </div>
              <div className="WeeklyProductItems col-12 col-lg-9">
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {products.map((product, index) => (
                    <NewCard
                      key={index}
                      product={product}
                      Ratting={this.Ratting}
                    />
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default NewArrival;

function NewCard({ product, Ratting }) {
  return (
    <div className="p-2">
      <div className="WeeklyProductItem card">
        <Link to={"/ProductDetails/"+product.product_code}>
          <div className="WeeklyProductItemImage ">
            <img className="card-img img-fluid" src={product.image} />
          </div>
          <div className="card-body text-start">
            <h6 className="text-dark">{product.title}</h6>
            <p className="text-secondary mt-2 mb-2">{checkDiscount(product)}</p>
            <div className="d-flex flex-column justify-content-between">
            <div
                className="ratting mt-1 mt-sm-0 "
                dangerouslySetInnerHTML={{
                  __html: Ratting(product.star),
                }}
              />
              <span className="price mt-2">
                {product.unit_price} টাকা/{product.unit}
              </span>
              
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

const checkDiscount = ({
  stock,
  discount_type,
  discount_percentage,
  flat_discount,
}) => {
  if (stock === "NO") return "স্টক আউট";
  if (stock === "CS") return "শীঘ্রই আসছে";
  if (stock === "YES" && discount_type === "Percentage")
    return `${discount_percentage}  % অফ`;
  if (stock === "YES" && discount_type === "Flat")
    return `${flat_discount} টাকা ডিস্কাউন্ট`;
  return "";
};
